'use client';

import React from 'react';
import { Quote, Mail } from 'lucide-react';

const perspectives = [
  {
    id: 'p-001',
    title: 'Built for Working Professionals',
    body: 'REUSA programmes are designed around the realities of a working professional — flexible, practical, and directly applicable to the South African and African property market.',
  },
  {
    id: 'p-002',
    title: 'Pan-African Real Estate Education',
    body: 'From Johannesburg to Lagos, Nairobi to Cape Town — our curriculum reflects the diversity, complexity, and opportunity of African real estate markets.',
  },
  {
    id: 'p-003',
    title: 'Industry-Informed, Not Just Academic',
    body: 'Every programme is developed in consultation with active industry practitioners. The content reflects real deals, real data, and real professional challenges.',
  },
  {
    id: 'p-004',
    title: 'Professional & Executive Pathways',
    body: 'Whether you are starting your career or leading an organisation, REUSA offers structured pathways from foundational practice to executive leadership in property.',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="section-pad-lg bg-background" id="testimonials">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 xl:px-16">
        <div className="max-w-2xl mb-14">
          <div className="flex items-center gap-3 mb-4">
            <div className="divider-gold" />
            <span className="label-caps">Why REUSA</span>
          </div>
          <h2 className="font-serif text-section-title text-foreground">
            Education Designed for
            <br />
            <span className="italic">African Real Estate Professionals</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12">
          {perspectives?.map((item) => (
            <div
              key={item?.id}
              className="bg-card border border-border rounded-2xl p-8 luxury-shadow relative overflow-hidden"
            >
              <div className="absolute top-5 right-6 opacity-5">
                <Quote size={56} className="text-primary" />
              </div>
              <h3 className="font-serif font-semibold text-lg text-foreground mb-3">
                {item?.title}
              </h3>
              <p className="font-sans text-sm text-muted-foreground leading-relaxed">
                {item?.body}
              </p>
            </div>
          ))}
        </div>

        {/* Student voice CTA */}
        <div className="bg-secondary border border-border rounded-2xl p-8 text-center">
          <p className="font-sans text-sm text-muted-foreground mb-4 max-w-lg mx-auto">
            Are you a current student or graduate? We would love to hear your story and share your experience with the REUSA community.
          </p>
          <a
            href="mailto:admissions@reusa.education?subject=Share My Story"
            className="btn-outline inline-flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-sm"
          >
            <Mail size={15} />
            Share Your Experience
          </a>
        </div>
      </div>
    </section>
  );
}